import React, { useMemo } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { ModalConfirmation } from '@adsk/alloy-react-modal';
import {
  useCurrentProductId,
  useProjectEntitlements,
} from '@adsk/alloy-provider';
import PropTypes from 'prop-types';

const RemoveRoleAndCurrentProductAccessConfirmationModal = ({
  onClose,
  onConfirm,
  show,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const currentProductId = useCurrentProductId();
  const { currentProject } = useProjectEntitlements();
  const currentProductName = useMemo(
    () =>
      currentProject?.products.find(
        (product) => product.key === currentProductId
      )?.name,
    [currentProductId, currentProject]
  );

  return (
    <ModalConfirmation
      data-testid="RemoveCurrentProductAdminAccess_ModalConfirmation"
      isConfirmationButtonAlert
      message={
        <div>
          {T.translate(
            'REMOVE_ROLE_AND_CURRENT_PRODUCT_ACCESS_CONFIRM_MODAL.BODY',
            { product: currentProductName }
          )}
        </div>
      }
      onClose={onClose}
      onConfirm={onConfirm}
      show={!!show}
      title={T.translate(
        'REMOVE_ROLE_AND_CURRENT_PRODUCT_ACCESS_CONFIRM_MODAL.TITLE'
      )}
    />
  );
};

RemoveRoleAndCurrentProductAccessConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

RemoveRoleAndCurrentProductAccessConfirmationModal.defaultProps = {
  show: false,
};

export default RemoveRoleAndCurrentProductAccessConfirmationModal;
